import type { InternalDropdownOption } from '~/components/DropdownTreeSingleSelect/types';

/**
 * Recursively update isVisible=true and isExpanded=hasSelected for all options.
 * @param options - The options to update.
 * @returns The updated options.
 */
export function updateIsVisibleTrueRecursive(
  options: InternalDropdownOption[],
): InternalDropdownOption[] {
  return options.map(
    (option): InternalDropdownOption => ({
      ...option,
      isVisible: true,
      isExpanded: option.hasSelected,
      children: option.children
        ? updateIsVisibleTrueRecursive(option.children)
        : undefined,
    }),
  );
}
